import { render, staticRenderFns } from "./MealCartPanel.vue?vue&type=template&id=70fb6670&scoped=true"
import script from "./MealCartPanel.vue?vue&type=script&lang=js"
export * from "./MealCartPanel.vue?vue&type=script&lang=js"
import style0 from "./MealCartPanel.vue?vue&type=style&index=0&id=70fb6670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb6670",
  null
  
)

export default component.exports